/**
 * Mapbox
 * 
 * @Author: Focci
 * @Date: 2023-06-16 16:33:42
 * @Last Modified by: Focci
 * @Last Modified time: 2023-06-16 16:33:42
 */

import Map from 'react-map-gl'
import { forwardRef } from 'react'
import { mapboxDefaultCoord, mapboxStyle, mapboxToken } from '@lib/config'
import 'mapbox-gl/dist/mapbox-gl.css'

function Mapbox({
  children,
  defaultViewState = mapboxDefaultCoord,
  ...props 
}, ref) {
  return (
    <Map
      initialViewState={defaultViewState}
      mapStyle={mapboxStyle}
      mapboxAccessToken={mapboxToken}
      className="relative"
      {...props}
      ref={ref}
    >
      {children}
    </Map>
  )
}

export default forwardRef(Mapbox)
